import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import last from 'lodash/last'
import styled from 'styled-components'
import { getIsSbs } from '../../util/sbs'

import { Flex, Box } from 'pcln-design-system'
import {
  Loader as LoaderCC,
  ItinerarySkeleton,
  ItinerarySliceSkeleton,
  Repeat,
} from '@pcln/fly-ui-components'

import { translateSearchRequest } from '../../util/translateSearchRequest'

function passengerCount(travelers) {
  return Object.keys(travelers).reduce((acc, cur) => acc + travelers[cur], 0)
}

const NUM_SKELETON_ITINS = 5

const WrapperFlex = styled(Flex)`
  min-height: 152px;
`

export function Loader({ ctaTitle, searchRequest }) {
  const { tripType, travelers } = translateSearchRequest(searchRequest)
  const origin = get(searchRequest, 'slices[0].originAirport')
  const departDate = get(searchRequest, 'slices[0].travelDate')
  const sliceCount = get(searchRequest, 'slices.length', 2)
  let destination
  let returnDate

  if (tripType === 'RT') {
    destination = get(searchRequest, 'slices[0].destinationAirport')
  } else {
    destination = last(searchRequest.slices).destinationAirport
  }

  if (tripType !== 'OW') {
    returnDate = last(searchRequest.slices).travelDate
  }

  return (
    <React.Fragment>
      <Box mt={2} mb={3}>
        <WrapperFlex
          flexDirection={'column'}
          alignItems={'center'}
          data-autobot-element-id={'FLIGHTS_SEARCH_MODERN_LOADING_SCREEN'}
        >
          <LoaderCC
            ctaTitle={ctaTitle}
            origin={origin}
            destination={destination}
            departDate={departDate}
            returnDate={returnDate}
            passengerCount={passengerCount(travelers)}
            tripType={tripType}
          />
        </WrapperFlex>
      </Box>
      <Repeat times={NUM_SKELETON_ITINS}>
        <Box mb={'10px'} px={0}>
          {tripType !== 'MD' || getIsSbs() ? (
            <ItinerarySliceSkeleton />
          ) : (
            <ItinerarySkeleton slices={sliceCount} />
          )}
        </Box>
      </Repeat>
    </React.Fragment>
  )
}

Loader.propTypes = {
  ctaTitle: PropTypes.string,
  searchRequest: PropTypes.shape({
    slicesURL: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
    slices: PropTypes.array.isRequired,
    airports: PropTypes.object.isRequired,
  }).isRequired,
}
